import { formatDateTime } from 'utilities/calendarFunctions';

interface ColumnHeadingProps {
	date: string;
	showDayView: (date: string) => void;
}

export default function ColumnHeading(props: ColumnHeadingProps) {
	const { date, showDayView } = props;

	const today = new Date();

	const thisDay = formatDateTime(date);

	const day = thisDay.getDay();
	const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
	const todayClassModifier = today.toDateString() === thisDay.toDateString() ? ' is-today' : '';

	return (
		<div className={`day-col day-col-heading ${todayClassModifier}`} onClick={() => showDayView(date)}>
			<span className="day-of-month day-numeric">{thisDay.getDate()}</span>
			<span className="day-of-week day-proper-name">{dayNames[day]}</span>
		</div>
	);
}